export const algoliaUrls = {
  algoliaIndex: 'DB_Cochez/query',
}
